import React, { useState } from 'react'

import { Avatar, Table, Button, Popconfirm, Col, Row, Divider } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import _ from 'lodash'
import { ButtonEx } from '../../../../styles/button.style'
import { useDispatch, useSelector } from 'react-redux'
import {
  getMaterialByHeroId,
  getMaterials,
  addHeroMaterial,
  updateMinQuantity,
  deleteProductById
} from '../../../../modules/material'
import WrappedHeroMaterialForm from './HeroMaterialForm'
import WrappedUpdateMinQuantityForm from './UpdateMinQuantity'

export const HeroProducts = ({ hero }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visibleMin, setVisibleMin] = useState(false)
  const [formDataMin, setFormDataMin] = useState({})

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getMaterialByHeroId(hero.id))
      await dispatch(getMaterials())
    }

    fetch()
  }, [])

  const { heroProducts, materials, isLoading } = useSelector(
    (state) => ({
      heroProducts: state.material.heroProducts,
      materials: state.material.materials,
      isLoading: state.material.isLoading

    }),
    []
  )
  const myMaterial = heroProducts.map(
    (heroProducts) => heroProducts.material
  )
  const stateList = myMaterial.map(
    (item) => item.id
  )

  const columns = [
    {
      title: 'Product',
      dataIndex: 'material.image',
      key: 'material.image',
      render: (name, row) => (
        <Avatar src={row.material.image && row.material.image} />
      )
    },
    {
      title: 'Product Category',
      dataIndex: 'material.category.name',
      key: 'material.category.name'
    },
    {
      title: 'Name',
      dataIndex: 'material.name',
      key: 'material.name'
    },
    {
      title: 'Common Name',
      dataIndex: 'material.commonName',
      key: 'material.commonName'
    },
    {
      title: 'Min Quantity',
      dataIndex: 'minQuantity',
      key: 'minQuantity',
      render: (name, row) => {
        switch (row.minQuantity) {
          case 'NO_LIMIT': {
            return 'ไม่จำกัด'
          }
          case 'UNIT_10': {
            return '> 10'
          }
          case 'UNIT_100': {
            return '> 100'
          }
          case 'UNIT_1000': {
            return '> 1000'
          }
          default: {
            return 'Not Specify'
          }
        }
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClickMin(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClickMin = (e, record) => {
    e.preventDefault()
    setVisibleMin(true)
    setFormDataMin(record)
  }

  const onCloseModalMin = async () => {
    await dispatch(getMaterialByHeroId(hero.id))
    await setVisibleMin(false)
  }

  const onOkMin = async (data) => {
    if (!_.isEmpty(formDataMin)) {
      await dispatch(updateMinQuantity(data))
    }
    await dispatch(getMaterialByHeroId(hero.id))
    await setVisibleMin(false)
    await setFormDataMin({})
  }

  // function fetch() {
  //   dispatch(getMaterialByHeroId(hero.id))
  //   dispatch (getMaterials())
  // }

  async function onDelete(id) {
    await dispatch(deleteProductById(id))
    await dispatch(getMaterialByHeroId(hero.id))
  }

  const onClick = (e) => {
    e.preventDefault()
    setVisible(true)
  }

  const onCloseModal = () => {
    setVisible(false)
  }

  const onOk = async (materialIds) => {
    const data = {
      heroId: hero.id,
      materialIdList: materialIds
    }
    await dispatch(addHeroMaterial(data))
    await setVisible(false)
    await dispatch(getMaterialByHeroId(hero.id))
  }


  const HeaderTable = () => {
    return (
      <Row type="flex" justify="end">
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              เพิ่มวัสดุ
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }



  // useDeepEffect(() => {
  //   if (!isEmpty(hero)) {
  //     fetch()
  //   }
  // }, [hero])

  return (
    <div>
      <Table
        loading={isLoading}
        title={HeaderTable}
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={heroProducts}
        columns={columns}
      />
      <WrappedHeroMaterialForm
        materials={materials}
        myMaterials={stateList}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
      <WrappedUpdateMinQuantityForm
        formDataMin={formDataMin}
        visibleMin={visibleMin}
        onOkMin={onOkMin}
        onCancelMin={onCloseModalMin}
      />
    </div>
  )
}

export default HeroProducts
